<template>
    <div class="view pa24">
      <!-- 添加表格 -->
      <el-table :data="tableData" style="width: 100%" v-loading="loading" :header-cell-style="{textAlign: 'center'}"
        :cell-style="{textAlign: 'center'}">
        <el-table-column prop="customName" label="产品名称" />
        <el-table-column prop="parentName" label="所属父级" />
        <el-table-column prop="stockNum" label="库存数量" />
        <el-table-column prop="stockWarningNum" label="预警数量" />
        <el-table-column prop="needNum" label="需补充数量" />
        <!-- 有就显示 位置 没有就显示-- -->
        <el-table-column prop="location" label="所属位置">
          <template slot-scope="scope">
            {{scope.row.location || '--'}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="提醒时间" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleReplenish(scope.row)">已补货</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageParams.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
</template>
<script>
  import { noPage, pageClassList, pageWarn, addWarn } from '@/api/customPageClass.js'
  export default {
    name: "addStoreCode",
    components: {},
    props: [],
    data() {
      let token = localStorage.getItem("token")
      return {
        upParams: {
          token: token
        },
        title: '产品预警',
        dialogVisible: false,
        ruleForm: {
          parentId: '',
          classType: '',
          parentName: '',
        },
        rules: {},
        id: '',
        classList: [],
        expandOnClickNode: false,
        parentId: '',
        classType: '',
        fileList: [],
        btnLoading: false,

        // 新增表格相关数据
        tableData: [],
        loading: false,
        total: 0,
        pageParams: {
          pageNum: 1,
          pageSize: 10
        }
      };
    },
    computed: {
      dynamicRules() {
        return (index) => {
          return [{
            required: true,
            message: '这是必填项',
            trigger: 'blur'
          },]
        }
      }
    },
    onShow() {
    },
    created() {
      
      this.getTableData()
    },
    methods: {
      closeDialog() {
        this.$emit('getList')
      },
      openDialog(classType) {
        this.dialogVisible = true
        this.classType = classType
        this.pageParams.pageNum = 1
        this.getTableData(classType)
      },
      goBack() {
        this.dialogVisible = false
      },

      // 获取表格数据
      async getTableData(classType) {
        this.loading = true
        try {
          const params = {
            ...this.pageParams,
            classType: classType || 0
          }
          const res = await pageWarn(params)
          if (res.code === 200) {
            this.tableData = res.data.list
            this.total = res.data.total
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      },

      // 处理已补货操作
      async handleReplenish(row) {
        try {
          const res = await addWarn({ id: row.id })
          if (res.code === 200) {
            this.$message.success('补货成功')
            this.getTableData(this.classType)
          } else {
            this.$message.error(res.msg || '补货失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('补货失败')
        }
      },

      // 分页相关方法
      handleSizeChange(val) {
        this.pageParams.pageSize = val
        this.getTableData(this.classType)
      },

      handleCurrentChange(val) {
        this.pageParams.pageNum = val
        this.getTableData(this.classType)
      }
    },
  };
</script>
<style lang="scss" scoped>
  .ml10 {
    margin-left: 10 rpx;
  }

  .children-item {
    width: 50%;
  }

  .main-select-tree {}

  .orderTitle {
    font-size: 16px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
    padding: 0px 60px 6px 55px;
  }

  .subBtn {
    text-align: right;
    margin-top: 20px;
  }

  .codeType {}

  .codeWrap {
    margin-top: 20px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
</style>